import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr/index'

const companyBillingApi = createAggrApiInstance(aggr.CompanyBillingApi)

export const getCompanyBillingSubTotal = async () => {
  const res = await handleApiStatus(() => companyBillingApi.billingGetcompanysubtotal())
  return res
}

export const getCompanies = async (reqData: aggr.BillingCompanyInfoRq) => {
  const res = await handleApiStatus(() => companyBillingApi.billingGetcompanies(reqData))
  return res
}

export const getBillInfo = async (reqData: aggr.BillInfoRq) => {
  const res = await handleApiStatus(() => companyBillingApi.billingGetbillinfo(reqData))
  return res
}

export const getContact = async (reqDdata: aggr.BillingGetContactRq) => {
  const res = await handleApiStatus(() => companyBillingApi.billingGetcontact(reqDdata))
  return res
}

export const updateContact = async (reqData: aggr.BillingUpdateContactRq) => {
  const res = await handleApiStatus(() => companyBillingApi.billingUpdatecontact(reqData))
  return res
}
